import React from 'react';
import Person from './Person/Person';
import './App.css';

function App() {
  return (
    <div className="App">
    <Person name="Isha" age="20"/>
    <Person name="Arsh" age="22"/>
</div>
  );
}

export default App;
